import PremiumListingCard from './PremiumListingCard.component';

export default PremiumListingCard;